import request from "./request.js";

export default {
  // 登录
  showQuestions: (data) => {
    return request({
      url: "api/admin/question/showQuestions/" + data,
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  addQuestion: (data) => {
    return request({
      url: "api/admin/question/addQuestion",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateQuestion: (data) => {
    return request({
      url: "api/admin/question/updateQuestion",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
